import { AppModal } from 'shared/UI/UIKit/Modal';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { EducationClassForm } from 'entities/education-class';
import { AppCopyIcon } from 'shared/UI/UIKit/icons/Copy';
import type { EducationClass } from 'shared/api';
import { useCopyEducationClass } from '../model';
import styles from './styles.module.scss';

interface CopyEducationClassProps {
  selectedEducationClass: EducationClass;
}

export const CopyEducationClass = ({ selectedEducationClass }: CopyEducationClassProps) => {
  const {
    state: { form, isLoading, visible },
    methods: { showModal, onSubmit, hideModal },
  } = useCopyEducationClass(selectedEducationClass);

  const footer = (
    <AppFlex direction="row">
      <AppButton onClick={onSubmit}>Создать</AppButton>
      <AppButton type="outline" onClick={hideModal}>
        Отмена
      </AppButton>
    </AppFlex>
  );

  return (
    <>
      <AppCopyIcon onClick={showModal} className={styles.icon} />

      <AppModal
        visible={visible}
        maskClosable={false}
        onCancel={hideModal}
        content={<EducationClassForm form={form} />}
        destroyOnClose
        footer={footer}
        loading={isLoading}
        title="Создать класс"
      />
    </>
  );
};
